import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import styled from 'styled-components';
import contactImage from '../assets/images/contact.jpg';
import { PrimaryButton, SecondaryButton } from '../components/Buttons';
import ContactPageSprite from '../assets/images/contactpage_sprite.png';
import { ImageLazyLoad } from '../components/ImageLazyLoad';
import { FullWidthContainer } from '../components/FullWidthContainer';
import thankyouImg from '../assets/images/thankyou_contactform.png';
import { StickyTag } from '../components/StickyTag';

const SpacerDiv = styled.div`
  height: 90px;

  @media (max-width: 566px) {
    height: 50px;
  }
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

const ContactHeading = styled.div`
  height: 60px;
  width: max-content;
  max-width: 100%;
  color: #1d1d1d;
  font-family: Avenir;
  font-size: 60px;
  font-weight: 900;
  letter-spacing: -0.15px;
  font-family: AvenirMedium;
  height: max-content;
  line-height: 100%;

  @media (max-width: 991px) {
    font-size: 36px;
  }

  @media (max-width: 566px) {
    font-size: 28px;
  }
`;

const ContactDescription = styled.div`
  color: #1d1d1d;
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.15px;
  line-height: 36px;
`;

const StyledInput = styled.input`
  border: none;
  border-radius: 0;
  background-clip: padding-box;
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.15px;
  color: #8d848d;
  line-height: 36px;
  border-bottom: ${(props) =>
    props.error && props.error != '' ? '2px solid red' : '2px solid #e2dfe2'};
  padding: 0.5em 0;
  transition: border-color 300ms ease-in;
  width: 100%;
  margin: 9px 0px;

  :focus {
    outline: none;
    border-bottom-color: ${(props) => (props.error && props.error != '' ? 'red' : 'grey')};
  }

  ::placeholder {
    color: #8d848d;
    opacity: 1;
  }
`;

const StyledStickyTagWrapper = styled.div`
  position: sticky;
  left: 35px;
  top: 90px;
  z-index: 2;

  @media (max-width: 769px) {
    display: none;
  }
`;

const StyledImage = styled.div`
  width: 350px;
  height: 467px;
  background: url(${(props) => props.imgSrc}) center center;
  background-size: cover;

  animation: playOut 1.5s steps(12) forwards;

  &:hover {
    -webkit-animation: play 1.5s steps(12) forwards;
    -moz-animation: play 1.5s steps(12) forwards;
    -ms-animation: play 1.5s steps(12) forwards;
    -o-animation: play 1.5s steps(12) forwards;
    animation: play 1.5s steps(12) forwards;
  }

  @keyframes play {
    from {
      background-position: 0;
    }
    to {
      background-position: -4200px;
    }
  }

  @keyframes playOut {
    from {
      background-position: -4200px;
    }
    to {
      background-position: 0;
    }
  }

  @media (max-width: 991px) {
    display: none;
  }
`;

const StyledRow = styled.div`
  min-height: 400px;
`;

const Heading = styled.h1`
  color: #000;
  font-size: 4em;
  text-align: left;
  font-weight: bold;
  font-family: AvenirMedium;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

const Contact = (props) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = () => {
    console.log(emailError, name, subject, email);
    if (!emailError && name && subject && email) {
      setLoading(true);
      fetch('https://us-central1-wrp-website.cloudfunctions.net/SendEmail', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          RecieverEmail: 'connect@werplay.com',
          Subject: subject,
          body: `Sender Name: ${name}
                 Sender Email: ${email} 
                 Body: ${body}`,
        }),
      })
        .then((response) => {
          setLoading(false);
          setEmailSent(true);
        })
        .catch((err) => {
          setLoading(false);
          alert(err);
        });
    } else {
      alert('Please provide correct information.');
    }
  };

  const validateEmail = (email) => {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = regex.test(String(email).toLowerCase());
    if (!result) {
      setEmailError('Email is not valid');
    } else {
      setEmailError('');
    }
  };

  return (
    <Layout showMothership={false}>
      <SmallSpacerDiv />
      <div className='container'>
        {emailSent && (
          <React.Fragment>
            <SmallSpacerDiv />
            <Heading>Thank you.</Heading>
            <ContactDescription className='pt-0'>
              We will get back to you shortly. Yours Truly.
            </ContactDescription>
            <div>
              <FullWidthContainer>
                <img src={thankyouImg} />
              </FullWidthContainer>
            </div>
          </React.Fragment>
        )}
        {!emailSent && (
          <div className='row py-4 mt-4'>
            <div className='col col-2 d-none d-md-block'>
              <StyledStickyTagWrapper id='sticky'>
                <StickyTag location='left'>
                  <a href='https://www.facebook.com/we.R.play/' target='_blank'>
                    <img
                      src={require('../assets/images/facebook-social.png')}
                      style={{
                        width: '24px',
                        height: '24px',
                        display: 'block',
                        margin: '10px 0',
                        filter: 'invert(0.6)',
                      }}
                    />
                  </a>
                  <a href='https://www.instagram.com/we.r.play/' target='_blank'>
                    <img
                      src={require('../assets/images/instagram-social.png')}
                      style={{
                        width: '24px',
                        height: '24px',
                        display: 'block',
                        margin: '10px 0',
                        filter: 'invert(0.6)',
                      }}
                    />
                  </a>
                  <a href='https://twitter.com/werplay' target='_blank'>
                    <img
                      src={require('../assets/images/twitter-social.png')}
                      style={{
                        width: '24px',
                        height: '24px',
                        display: 'block',
                        margin: '10px 0',
                        filter: 'invert(0.6)',
                      }}
                    />
                  </a>
                </StickyTag>
              </StyledStickyTagWrapper>
            </div>
            <div className='col px-4 col-12 col-sm-10 py-4'>
              <ContactHeading>Contact the mothership</ContactHeading>
              <ContactDescription>
                Hello!👋 Don’t be shy. Let’s get in touch, it will be worth it.
              </ContactDescription>
              <StyledRow className='d-flex mr-4 w-100 my-4'>
                <StyledImage imgSrc={ContactPageSprite} />
                <div className='d-flex flex-column mx-0 mx-lg-4 px-lg-4 flex-grow-1'>
                  <React.Fragment>
                    <StyledInput
                      type='text'
                      id='name'
                      placeholder='Name'
                      onChange={(e) => setName(e.target.value)}
                    />
                    <StyledInput
                      error={emailError}
                      type='text'
                      id='email'
                      placeholder='Email Address'
                      text={email}
                      onChange={(event) => {
                        setEmail(event.target.value);
                        validateEmail(event.target.value);
                      }}
                    />
                    <StyledInput
                      type='text'
                      id='subject'
                      placeholder='Subject'
                      onChange={(e) => setSubject(e.target.value)}
                    />
                    <StyledInput
                      type='text'
                      id='description'
                      placeholder='Briefly tell us about your project and how can we help you?'
                      onChange={(e) => setBody(e.target.value)}
                    />
                    <div className='mt-auto pb-1'>
                      {loading && (
                        <ContactDescription className='pt-0'>
                          Sending Your Email...
                        </ContactDescription>
                      )}
                      {!loading && (
                        <PrimaryButton text='Send' invert='true' onClick={() => sendEmail()} />
                      )}
                    </div>
                  </React.Fragment>
                </div>
              </StyledRow>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Contact;
